<template>
  <div class="w-full h-screen bg-white overflow-x-hidden">
    <Navbar @sidebarDismissed=" (value) => {expand(value)}"  class=" w-full sticky top-0 z-50"/>
    <div>
      <Sidebar class="sidebar"/>
      <div :class="[!expandBody ? 'main px-5 space-y-2 margin mb-16' : 'main px-5 space-y-2 mb-16']">
        <!-- the top route and username grid -->
        <div class="justify-between flex pt-5 text-size-md font-medium text-gray-500 w-full">
          <span class=" text-emerald-500" >> Home > Create a Service Report Step 2</span>
          <span v-if="employee !== null">{{ employee.firstname }} {{ employee.surname }} </span>
        </div>
        <!-- the requests charts -->
        <div class="grid gap-6 grid-rows-1 grid-cols-1">
          <div class=" shadow-md text-gray-400 col-span-full border hover:shadow-lg mt-4 bg-white">
            <!-- The chart title -->
            <div class="ml-8 flex mt-6 mb-4 items-center space-x-1">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-emerald-500 fill-current" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M24,24H3a3,3,0,0,1-3-3V0H2V21a1,1,0,0,0,1,1H24Z"/><rect x="14" y="11" width="2" height="9"/><rect x="6" y="11" width="2" height="9"/><rect x="18" y="6" width="2" height="14"/><rect x="10" y="6" width="2" height="14"/></svg> -->
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                <path d="m12,12c3.309,0,6-2.691,6-6S15.309,0,12,0s-6,2.691-6,6,2.691,6,6,6Zm0-10c2.206,0,4,1.794,4,4s-1.794,4-4,4-4-1.794-4-4,1.794-4,4-4Zm9,17v5h-2v-5c0-1.654-1.346-3-3-3h-2l-1.333,2,1.333,6h-4l1.333-6-1.333-2h-2c-1.654,0-3,1.346-3,3v5h-2v-5c0-2.757,2.243-5,5-5h8c2.757,0,5,2.243,5,5Z"/>
              </svg> -->
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512"><path d="M18.4,7.379a1.128,1.128,0,0,1-.769-.754h0a8,8,0,1,0-15.1,5.237A1.046,1.046,0,0,1,2.223,13.1,5.5,5.5,0,0,0,.057,18.3,5.622,5.622,0,0,0,5.683,23H11a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H5.683a3.614,3.614,0,0,1-3.646-2.981,3.456,3.456,0,0,1,1.376-3.313A3.021,3.021,0,0,0,4.4,11.141a6.113,6.113,0,0,1-.073-4.126A5.956,5.956,0,0,1,9.215,3.05,6.109,6.109,0,0,1,9.987,3a5.984,5.984,0,0,1,5.756,4.28,2.977,2.977,0,0,0,2.01,1.99,5.934,5.934,0,0,1,.778,11.09.976.976,0,0,0-.531.888h0a.988.988,0,0,0,1.388.915c4.134-1.987,6.38-7.214,2.88-12.264A6.935,6.935,0,0,0,18.4,7.379Z"/><path d="M18.707,16.707a1,1,0,0,0,0-1.414l-1.586-1.586a3,3,0,0,0-4.242,0l-1.586,1.586a1,1,0,0,0,1.414,1.414L14,15.414V23a1,1,0,0,0,2,0V15.414l1.293,1.293a1,1,0,0,0,1.414,0Z"/></svg> -->
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="m17,0H7C4.243,0,2,2.243,2,5v14c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5ZM7,2h10c1.654,0,3,1.346,3,3H4c0-1.654,1.346-3,3-3Zm10,20H7c-1.654,0-3-1.346-3-3V7h16v12c0,1.654-1.346,3-3,3Zm0-11c0,.553-.448,1-1,1h-8c-.552,0-1-.447-1-1s.448-1,1-1h8c.552,0,1,.447,1,1Zm-4,4c0,.553-.448,1-1,1h-4c-.552,0-1-.447-1-1s.448-1,1-1h4c.552,0,1,.447,1,1Z"/></svg> -->
              <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                <path d="m13,5v2H5v-2h8Zm-7,6h6v-2h-6v2Zm17,4.764v5.236c0,1.654-1.346,3-3,3H1V0h17c1.654,0,3,1.346,3,3v8.764l2,4ZM3,22h12V2H3v20Zm18-5.764l-2-4V3c0-.551-.448-1-1-1h-1v20h3c.552,0,1-.449,1-1v-4.764Z"/>
              </svg>
              <p class="text-left text-size-md font-medium text-gray-600">Create a Report</p>
            </div>
            <!-- The service report steps -->
            <div class="flex items-center col-span-full mx-4 mt-5 pr-2">
              <span class="ml-4 mr-0.5 cursor-pointer text-size-sm font-medium bg-emerald-600 ring-emerald-600 ring-2 text-white py-0 px-1">1</span>
              <div class="flex-auto cursor-pointer text-size border-t-2 transition duration-500 ease-in-out border-emerald-600"></div>
              <span class="ml-0.5 mr-0.5 cursor-pointer text-size-sm font-medium bg-emerald-600 ring-emerald-600 ring-2 text-white py-0 px-1">2</span>
              <div class="flex-auto animate-pulse cursor-pointer border-t-2 transition duration-500 ease-in-out border-emerald-600"></div>
              <span class="cursor-pointer mx-0.5 text-size-sm font-medium ring-emerald-600 ring-2 text-gray-500 py-0 px-1">3</span>
            </div>
            <!--  the reports -->
            <div class="ml-8 pb-8 mt-4">
              <div
                class="ring-1 py-2 text-left cursor-pointer ring-gray-200 shadow-md mr-10 pl-1 chart-height"
              >
                <div class="px-4 py-2 space-y-2.5">
                    <!-- the lodging details -->
                    <div class="py-6 grid grid-flow-row grid-cols-1 grid-rows-1 gap-x-4 gap-y-2 sm:gap-y-1.5">
                      <div class="flex space-x-0.5 text-right mb-2 justify-between">
                        <div class="my-auto"></div>
                        <div>
                          <button @click="clearData()" class="shadow inline-block box-shadow text-size-sm px-10 py-2 bg-emerald-600  text-white font-medium leading-tight transform focus:bg-red-600 focus:outline-none focus:ring-0 active:bg-red-800 transition duration-150 ease-in-out">Delete All</button>
                          <button @click="openModal()" class="shadow inline-block box-shadow text-size-sm px-8 py-2 bg-emerald-600  text-white font-medium leading-tight transform focus:bg-emerald-600 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">Add Details</button>
                        </div>
                      </div>
                      <!-- {{createServiceReportStep2}} -->
                      <!-- the service report -->
                      <div v-if="createServiceReportStep1?.serviceReportType?.name === 'Service Report'" class=" overflow-x-auto">
                        <table id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                            <thead>
                              <tr class="bg-emerald-600 pointer-events-none text-size-xs" style="">
                                <td class="py-3 px-2 text-left text-white font-bold">Day</td>
                                <td class="py-3 px-2 text-left text-white font-bold">Date</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Alcancar</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">ViiV</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">JDC</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Gates</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Total</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Observations</td>
                                <td class="py-3 px-2 border-l text-center text-white font-bold">Action</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(data, i) in serviceReportData" :key="i" class=" text-gray-600 text-size-sm" style="">
                                <td v-if="data.date !== 'Total' && data.date !== 'Percentage'" class="py-3 px-2 border text-left">{{ (i + 1) }}</td>
                                <td v-else></td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ formatData(data.date) }}</td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ data.alcancar }}</td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ data.viiv }}</td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ data.jdc }}</td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ data.gates }}</td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ data.total }}</td>
                                <td :class="['py-3 px-2 border text-left', data.date === 'Total' || data.date === 'Percentage' ? 'font-medium' : '']">{{ data.observations }}</td>
                                <td v-if="data.date !== 'Total' && data.date !== 'Percentage'" class="py-3 px-2 border text-center">
                                  <div class="flex mx-auto space-x-4">
                                    <svg @click="deleteServiceReportItem(i)" class="h-4 w-4 text-red-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4.707,15.293-1.414,1.414L12,13.414,8.707,16.707,7.293,15.293,10.586,12,7.293,8.707,8.707,7.293,12,10.586l3.293-3.293,1.414,1.414L13.414,12Z"/></svg>
                                    <svg @click="loadEditServiceDeliveryReportModal(i)" class="h-4 w-4 text-emerald-600 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M23,24H5c-.55,0-1-.45-1-1s.45-1,1-1H23c.55,0,1,.45,1,1s-.45,1-1,1ZM2.48,11.89c-.31,.73-.48,1.53-.48,2.34v4.35l-1.71,1.71c-.39,.39-.39,1.02,0,1.41,.2,.2,.45,.29,.71,.29s.51-.1,.71-.29l1.71-1.71H7.76c.81,0,1.61-.17,2.34-.48L2.48,11.89ZM20.91,7.83l-8.67,10.15c-.13,.15-.27,.29-.42,.42L3.59,10.17c.13-.14,.27-.28,.42-.41L14.17,1.1c1.78-1.54,4.47-1.45,6.14,.21l.39,.39c1.66,1.66,1.76,4.36,.22,6.13Z"/></svg>
                                  </div>
                                </td>
                                <td v-else></td>
                              </tr>
                            </tbody>
                        </table>
                      </div>

                      <!-- the data clerks report -->
                      <div v-if="createServiceReportStep1?.serviceReportType?.name === 'Data Clerks Report'" class=" overflow-x-auto">
                        <table id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                            <thead>
                              <tr class="bg-emerald-600 pointer-events-none text-size-xs" style="">
                                <td class="py-3 px-2 text-left text-white font-bold">#</td>
                                <td class="py-3 px-2 text-left text-white font-bold">Goals/Targets</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Percentage Achieved (Provider Score)</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Percentage Achieved (Supervisor Score)</td>
                                <td class="py-3 px-2 border-l text-center text-white font-bold">Action</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(data, i) in dataClerksReportData" :key="i" class=" text-gray-600 text-size-sm" style="">
                                <td v-if="data.goal !== 'Total'" class="py-3 px-2 border text-left">{{ (i + 1) }}</td>
                                <td v-else></td>
                                <td :class="['py-3 px-2 border text-left', data.goal === 'Total' ? 'font-medium' : '']">{{ data.goal}}</td>
                                <td :class="['py-3 px-2 border text-left', data.goal === 'Total' ? 'font-medium' : '']">{{ data.percentageAchieved }}%</td>
                                <td :class="['py-3 px-2 border text-left', data.goal === 'Total' ? 'font-medium' : '']">{{ data.supervisorScore }}%</td>
                                <td v-if="data.goal !== 'Total'" class="py-3 px-2 border text-center">
                                  <div class="flex mx-auto space-x-4">
                                    <svg @click="deleteDataClerkItem(i)" class="h-4 w-4 text-red-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4.707,15.293-1.414,1.414L12,13.414,8.707,16.707,7.293,15.293,10.586,12,7.293,8.707,8.707,7.293,12,10.586l3.293-3.293,1.414,1.414L13.414,12Z"/></svg>
                                    <svg @click="loadEditDataClerksModal(i)" class="h-4 w-4 text-emerald-600 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M23,24H5c-.55,0-1-.45-1-1s.45-1,1-1H23c.55,0,1,.45,1,1s-.45,1-1,1ZM2.48,11.89c-.31,.73-.48,1.53-.48,2.34v4.35l-1.71,1.71c-.39,.39-.39,1.02,0,1.41,.2,.2,.45,.29,.71,.29s.51-.1,.71-.29l1.71-1.71H7.76c.81,0,1.61-.17,2.34-.48L2.48,11.89ZM20.91,7.83l-8.67,10.15c-.13,.15-.27,.29-.42,.42L3.59,10.17c.13-.14,.27-.28,.42-.41L14.17,1.1c1.78-1.54,4.47-1.45,6.14,.21l.39,.39c1.66,1.66,1.76,4.36,.22,6.13Z"/></svg>
                                  </div>
                                </td>
                                <td v-else></td>
                              </tr>
                            </tbody>
                        </table>
                      </div>

                      <!-- the multi function report -->
                      <div v-if="createServiceReportStep1?.serviceReportType?.name === 'Multi Function Service Report'" class=" overflow-x-auto">
                        <table class="table-auto w-full shadow-md cursor-pointer">
                            <thead>
                              <tr class="bg-emerald-600 pointer-events-none text-size-xs" style="">
                                <td class="py-3 px-2 text-left text-white font-bold">Description</td>
                                <td class="py-3 px-2 text-left text-white font-bold">Planned</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Achieved</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">% Completion</td>
                                <td class="py-3 px-2 border-l text-left text-white font-bold">Observations</td>
                                <td class="py-3 px-2 border-l text-center text-white font-bold">Action</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(data, i) in multiFunctionServiceReportData" :key="i" class=" text-gray-600 text-size-sm" style="">
                                <td class="py-3 px-2 border text-left">{{ data.description }}</td>
                                <td class="py-3 px-2 border text-left">{{ data.planned }}</td>
                                <td class="py-3 px-2 border text-left">{{ data.achieved }}</td>
                                <td class="py-3 px-2 border text-left">{{ data.completion }}</td>
                                <td class="py-3 px-2 border text-left">{{ data.observations }}</td>
                                <td class="py-3 px-2 border text-center flex">
                                  <div class="flex mx-auto space-x-4">
                                    <svg @click="deleteMultiFunctionServiceReportItem(i)" class="h-4 w-4 text-red-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4.707,15.293-1.414,1.414L12,13.414,8.707,16.707,7.293,15.293,10.586,12,7.293,8.707,8.707,7.293,12,10.586l3.293-3.293,1.414,1.414L13.414,12Z"/></svg>
                                    <svg @click="loadEditMultiFunctionServiceModal(i)" class="h-4 w-4 text-emerald-600 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M23,24H5c-.55,0-1-.45-1-1s.45-1,1-1H23c.55,0,1,.45,1,1s-.45,1-1,1ZM2.48,11.89c-.31,.73-.48,1.53-.48,2.34v4.35l-1.71,1.71c-.39,.39-.39,1.02,0,1.41,.2,.2,.45,.29,.71,.29s.51-.1,.71-.29l1.71-1.71H7.76c.81,0,1.61-.17,2.34-.48L2.48,11.89ZM20.91,7.83l-8.67,10.15c-.13,.15-.27,.29-.42,.42L3.59,10.17c.13-.14,.27-.28,.42-.41L14.17,1.1c1.78-1.54,4.47-1.45,6.14,.21l.39,.39c1.66,1.66,1.76,4.36,.22,6.13Z"/></svg>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                      </div>

                    </div>
                <div class="w-full flex text-center mx-auto pt-1">
                    <div class="flex-1 mb-2">
                      <button
                        @click="back"
                        class="shadow inline-block box-shadow text-size-sm px-16 py-2 bg-emerald-500  text-white font-medium leading-tight transform focus:bg-emerald-500 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">
                          Back
                      </button>
                      <button
                        @click="next"
                        class="shadow inline-block box-shadow text-size-sm px-16 py-2 bg-emerald-500  text-white font-medium leading-tight transform focus:bg-emerald-500 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">
                          Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- add service report modal -->
    <TransitionRoot appear :show="isServiceReportAddOpen" @close="closeServiceReportAddModal()" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-80" />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block border w-full max-w-5xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
              >
                <DialogTitle
                  as="h4"
                  class="text-size font-medium leading-6 text-gray-600"
                >
                Add a Service Report Details
                </DialogTitle>
                <div class="grid grid-flow-row grid-cols-2 grid-rows-2 gap-4 py-4">
                  
                  <!-- date -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Date <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="date"
                        placeholder="Date"
                        required
                        type="date"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  
                  <!-- alcancar -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Alcancar <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="alcancar"
                        placeholder="Alcancar"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                  <!-- viiv -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">ViiV <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="viiv"
                        placeholder="ViiV"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                  <!-- jdc -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">JDC <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="jdc"
                        placeholder="JDC"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                   <!-- gates -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Gates <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="gates"
                        placeholder="Gates"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                  <!-- observations -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Observations <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="observations"
                        placeholder="Observations"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                </div>
                <div class="mt-2 mb-4 flex justify-center space-x-0.5">
                  <button
                    @click="closeServiceReportAddModal()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Cancel
                  </button>
                  <button
                    @click="addServiceReportData()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Save
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- edit service report modal -->
    <TransitionRoot appear :show="isServiceReportEditOpen" @close="closeServiceReportEditModal()" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-80" />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block border w-full max-w-5xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
              >
                <DialogTitle
                  as="h4"
                  class="text-size font-medium leading-6 text-gray-600"
                >
                Edit MI&E Advance
                </DialogTitle>
                 <div class="grid grid-flow-row grid-cols-2 grid-rows-2 gap-4 py-4">
                  
                  <!-- date -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Date <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="date"
                        placeholder="Date"
                        required
                        type="date"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  
                  <!-- alcancar -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Alcancar <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="alcancar"
                        placeholder="Alcancar"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                  <!-- viiv -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">ViiV <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="viiv"
                        placeholder="ViiV"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                  <!-- jdc -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">JDC <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="jdc"
                        placeholder="JDC"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                   <!-- gates -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Gates <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="gates"
                        placeholder="Gates"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                  <!-- observations -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Observations <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="observations"
                        placeholder="Observations"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                </div>
                <div class="mt-2 mb-4 flex justify-center space-x-0.5">
                  <button
                    @click="closeServiceReportEditModal()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Cancel
                  </button>
                  <button
                    @click="editServiceReportData()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Save
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- add data clerks report modal -->
    <TransitionRoot appear :show="isDataClerksReportAddOpen" @close="closeDataClerksReportAddModal()" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-80" />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block border w-full max-w-5xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
              >
                <DialogTitle
                  as="h4"
                  class="text-size font-medium leading-6 text-gray-600"
                >
                Add Data Clerk Report Details
                </DialogTitle>
                <div class="grid grid-flow-row grid-cols-2 gap-4 py-4">
                  <!-- description -->
                   <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Goal/Target <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="goal"
                        placeholder="Goal/Target"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- rate -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Percentage Achieved <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="percentageAchieved"
                        placeholder="Percentage Achieved"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- no of days -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Supervisor Score <span class="font-bold text-red-500">(Locked)  *</span></label>
                    <div class="flex ">
                      <input
                        v-model="supervisorScore"
                        placeholder="Supervisor Score"
                        required
                        type="number"
                        disabled
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                </div>
                <div class="mt-2 mb-4 flex justify-center space-x-0.5">
                  <button
                    @click="closeDataClerksReportAddModal()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Cancel
                  </button>
                  <button
                    @click="addDataClerksData()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Save
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- edit data clerks report modal -->
    <TransitionRoot appear :show="isDataClerksReportEditOpen" @close="closeDataClerksReportEditModal()" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-80" />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block border w-full max-w-5xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
              >
                <DialogTitle
                  as="h4"
                  class="text-size font-medium leading-6 text-gray-600"
                >
                Edit Data Clerks Report Details
                </DialogTitle>
                 <div class="grid grid-flow-row grid-cols-2 gap-4 py-4">
                  <!-- description -->
                   <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Goal/Target <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="goal"
                        placeholder="Goal/Target"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- rate -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Percentage Achieved <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="percentageAchieved"
                        placeholder="Percentage Achieved"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- no of days -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Supervisor Score <span class="font-bold text-red-500">(Locked)  *</span></label>
                    <div class="flex ">
                      <input
                        v-model="supervisorScore"
                        placeholder="Supervisor Score"
                        required
                        type="number"
                        disabled
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                </div>
                <div class="mt-2 mb-4 flex justify-center space-x-0.5">
                  <button
                    @click="closeDataClerksReportEditModal()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Cancel
                  </button>
                  <button
                    @click="editDataClerksData()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Save
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- add multi function service report modal -->
    <TransitionRoot appear :show="isMultiFunctionServiceReportAddOpen" @close="closeMultiFunctionServiceReportAddModal()" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-80" />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block border w-full max-w-5xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
              >
                <DialogTitle
                  as="h4"
                  class="text-size font-medium leading-6 text-gray-600"
                >
                Add Multi Function Service Report Details
                </DialogTitle>
                <div class="grid grid-flow-row grid-cols-2 gap-4 py-4">
                  <!-- description -->
                   <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Description <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="description"
                        placeholder="Description"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- planned -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Planned <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="planned"
                        placeholder="Planned"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- achieved -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Achieved <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="achieved"
                        placeholder="Achieved"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- completion -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Completion <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="completion"
                        placeholder="Completion"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- observations -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Observations <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="observations"
                        placeholder="Observations"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                </div>
                <div class="mt-2 mb-4 flex justify-center space-x-0.5">
                  <button
                    @click="closeMultiFunctionServiceReportAddModal()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Cancel
                  </button>
                  <button
                    @click="addMultiFunctionReportData()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Save
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- edit multi service report modal -->
    <TransitionRoot appear :show="isMultiFunctionServiceReportEditOpen" @close="closeMultiFunctionServiceReportEditModal()" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-80" />
            </TransitionChild>

            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block border w-full max-w-5xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
              >
                <DialogTitle
                  as="h4"
                  class="text-size font-medium leading-6 text-gray-600"
                >
                Edit Multi Function Service Report Details
                </DialogTitle>
                <div class="grid grid-flow-row grid-cols-2 gap-4 py-4">
                  <!-- description -->
                   <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Description <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="description"
                        placeholder="Description"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- planned -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Planned <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="planned"
                        placeholder="Planned"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- achieved -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Achieved <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="achieved"
                        placeholder="Achieved"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- completion -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Completion <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="completion"
                        placeholder="Completion"
                        required
                        type="number"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>
                  <!-- observations -->
                  <div class="col-span-full sm:col-span-1 ">
                    <label for="email" class="block text-size-md font-medium text-gray-600 text-left mb-2">Observations <span class="font-bold text-red-500">*</span></label>
                    <div class="flex ">
                      <input
                        v-model="observations"
                        placeholder="Observations"
                        required
                        type="text"
                        class="bg-gray-50 text-size-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/>
                    </div>
                  </div>

                </div>
                <div class="mt-2 mb-4 flex justify-center space-x-0.5">
                  <button
                    @click="closeMultiFunctionServiceReportEditModal()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Cancel
                  </button>
                  <button
                    @click="editMultiFunctionServiceData()"
                    type="button"
                    class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                    border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                    focus-visible:ring-offset-2 focus-visible:ring-emerald-500">
                    Save
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- the loader modal -->
    <Loader ref="loaderRef"/>
    <!-- the message loader -->
    <Message :title="title" :message="processMessage" ref="messageRef"/>
  </div>
</template>

<script>
import Navbar from '@/components/EmployeeNavbar.vue'
import Sidebar from '@/components/EmployeeSideBar.vue'
import { mapState } from 'vuex'
 import { ref } from 'vue'
import Message from './modals/Message.vue';
import Loader from './modals/Loader.vue';
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from '@headlessui/vue'

export default {
  computed: {
    ...mapState([
      'employee',
      'createServiceReportStep1',
      'createServiceReportStep2'
    ])
  },
  components: {
    Navbar,
    Sidebar,
    Loader,
    Message,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay
  },
  setup () {
    // opens the add modal
    const isServiceReportAddOpen = ref(false)
    const isDataClerksReportAddOpen = ref(false)
    const isMultiFunctionServiceReportAddOpen = ref(false)

    // opens the edit modal
    const isServiceReportEditOpen = ref(false)
    const isDataClerksReportEditOpen = ref(false)
    const isMultiFunctionServiceReportEditOpen = ref(false)
    return {
      isServiceReportAddOpen,
      isDataClerksReportAddOpen,
      isServiceReportEditOpen,
      isDataClerksReportEditOpen,
      isMultiFunctionServiceReportAddOpen,
      isMultiFunctionServiceReportEditOpen,
      
      closeServiceReportAddModal () {
        isServiceReportAddOpen.value = false
      },
      openServiceReportAddModal () {
        isServiceReportAddOpen.value = true
      },
      closeDataClerksReportAddModal () {
        isDataClerksReportAddOpen.value = false
      },
      openDataClerksReportAddModal () {
        isDataClerksReportAddOpen.value = true
      },

      closeServiceReportEditModal () {
        isServiceReportEditOpen.value = false
      },
      openServiceReportEditModal () {
        isServiceReportEditOpen.value = true
      },

      closeDataClerksReportEditModal () {
        isDataClerksReportEditOpen.value = false
      },
      openDataClerksReportEditModal () {
        isDataClerksReportEditOpen.value = true
      },
      closeMultiFunctionServiceReportAddModal () {
        isMultiFunctionServiceReportAddOpen.value = false
      },
      openMultiFunctionServiceReportAddModal () {
        isMultiFunctionServiceReportAddOpen.value = true
      },

      closeMultiFunctionServiceReportEditModal () {
        isMultiFunctionServiceReportEditOpen.value = false
      },
      openMultiFunctionServiceReportEditModal () {
        isMultiFunctionServiceReportEditOpen.value = true
      }
    }
  },
  name: 'create-request-3',
  props: {
  },
  data: () => {
    return {
      showLodgingAdvance: false,
      title: 'Error Message',
      processMessage: '',
      // service report
      date: '',
      alcancar: 0,
      viiv: 0,
      jdc: 0,
      gates: 0,
      observations: '',
      serviceReportData: [],

      // data clerks report
      goal: '',
      percentageAchieved: 0,
      supervisorScore: 0,
      dataClerksReportData: [],

      // multi function service report
      description: '',
      planned: '',
      achieved: '',
      completion: 0,
      multiFunctionServiceReportData: [],

      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  mounted () {
    // removing the submenu items selection
    if (this.employee !== null) {
      this.$store.commit('mutateActiveListItemIndex', 700)
      this.$store.commit('mutateSelectedSubMenuItem', 700)
    }
    
    // load the state data
    this.loadVuexData()
  },
  methods: {
    loadVuexData () {
      if (this.createServiceReportStep1?.serviceReportType?.name === 'Service Report' && this.createServiceReportStep2?.type === 'Service Report') {
        this.serviceReportData = this.createServiceReportStep2.data
      } else if (this.createServiceReportStep1?.serviceReportType?.name === 'Data Clerks Report' && this.createServiceReportStep2?.type === 'Data Clerks Report') {
        this.dataClerksReportData = this.createServiceReportStep2.data
      } else if (this.createServiceReportStep1?.serviceReportType?.name === 'Multi Function Service Report' && this.createServiceReportStep2?.type === 'Multi Function Service Report' ) {
        this.multiFunctionServiceReportData = this.createServiceReportStep2.data
      }
    },
    // saves the report data
    saveReport () {
      // the report data
      let reportData = null
      
      // save the report data
      if (this.createServiceReportStep1?.serviceReportType?.name === 'Service Report') {
        reportData = { type: this.createServiceReportStep1?.serviceReportType?.name, data: this.serviceReportData }
      } else if(this.createServiceReportStep1?.serviceReportType?.name === 'Data Clerks Report') {
        reportData = { type: this.createServiceReportStep1?.serviceReportType?.name, data: this.dataClerksReportData }
      } else {
        reportData = { type: this.createServiceReportStep1?.serviceReportType?.name, data: this.multiFunctionServiceReportData }
      }
      
      this.$store.commit('mutateCreateServiceReportStep2', reportData)
    },
    // compare rows
    compareRows (dataArray, rowData) {
      if (Array.isArray(dataArray)) {
        const size = dataArray.length
        const dataString = JSON.stringify(rowData)

        for (let i = 0; i < size; i++) {
          const dataRowItem = dataArray[i]
          const JSONDataString = JSON.stringify(dataRowItem)

          if (dataString === JSONDataString) {
            return true
          }
        }

        return false
      } else {
        return false
      }
    },
    editDataClerksData () {
      // check if the details are empty
      if (this.goal.trim() !== '' && !isNaN(this.percentageAchieved) && (this.percentageAchieved) >= 0 && this.percentageAchieved <= 100 && !isNaN(this.supervisorScore)) {
         // remove the grand total
        this.removeDataClerksGrandTotal()

        // adding the data
        const rowData = {
          goal: this.goal,
          percentageAchieved: this.percentageAchieved,
          supervisorScore: this.supervisorScore
        }
                
        // edit the data
        this.dataClerksReportData[this.selectedEditIndex] = rowData

        // calculate the grand total
        this.calculateDataClerksGrandTotal()

        //  close the edit modal
        this.closeDataClerksReportEditModal()
      }
    },
    addDataClerksData () {
      // check if the details are empty
      if (this.goal.trim() !== '' && !isNaN(this.percentageAchieved) && (this.percentageAchieved) >= 0 && this.percentageAchieved <= 100 && !isNaN(this.supervisorScore)) {
        // remove the grand total
        this.removeDataClerksGrandTotal()

        // adding the data
        const rowData = {
          goal: this.goal,
          percentageAchieved: this.percentageAchieved,
          supervisorScore: this.supervisorScore
        }
        // add it in the mie
        this.dataClerksReportData.push(rowData)

        // calculate the grand total
        this.calculateDataClerksGrandTotal()

        //  close the add modal
        this.closeDataClerksReportAddModal()
      }
    },
    addMultiFunctionReportData () {
      // check if the details are empty
      if (this.description.trim() !== '' && this.planned.trim() !== '' && this.achieved.trim() !== '' && !isNaN(this.completion) && this.completion >= 0 && this.completion <= 100  && this.observations.trim() !== '') {
        // adding the data
        const rowData = {
          description: this.description,
          planned: this.planned,
          achieved: this.achieved,
          completion: this.completion,
          observations: this.observations
        }
        // add it in the other
        this.multiFunctionServiceReportData.push(rowData)

        //  close the add modal
        this.closeMultiFunctionServiceReportAddModal()
        
        // save the data
        this.saveReport()
      }
    },
    editMultiFunctionServiceData () {
      // check if the details are empty
      if (this.description.trim() !== '' && this.planned.trim() !== '' && this.achieved.trim() !== '' && !isNaN(this.completion) && this.completion >= 0 && this.completion <= 100 && this.observations.trim() !== '') {
        // adding the data
        const rowData = {
          description: this.description,
          planned: this.planned,
          achieved: this.achieved,
          completion: this.completion,
          observations: this.observations
        }

        // add it in the other
        this.multiFunctionServiceReportData[this.selectedEditIndex] = rowData

        //  close the add modal
        this.closeMultiFunctionServiceReportEditModal()
        
        // save the data
        this.saveReport()
      }
    },
    // date difference in days
    dateDiff (startDate, endDate) {
      const date2 = new Date(endDate)
      const date1 = new Date(startDate)

      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // remove the time and time-zone details.
      const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
      const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

      return (Math.floor((utc2 - utc1) / _MS_PER_DAY) + 1);
    },
    // open the appropriate modal
    openModal () {
      if (this.createServiceReportStep1?.serviceReportType?.name === 'Service Report') {
        this.openServiceReportAddModal()
      } else if(this.createServiceReportStep1?.serviceReportType?.name === 'Data Clerks Report') {
        this.openDataClerksReportAddModal()
      } else {
        this.openMultiFunctionServiceReportAddModal()
      }
    },
    // load the edit modal
    loadEditServiceDeliveryReportModal (index) {
      // get the row details
      const rowData = this.serviceReportData[index]

      this.date = rowData.date
      this.alcancar = rowData.alcancar
      this.viiv = rowData.viiv
      this.jdc = rowData.jdc
      this.gates = rowData.gates
      this.observations = rowData.observations

      // set the index to be edited
      this.selectedEditIndex = index
      this.openServiceReportEditModal()
    },
    // load the edit modal
    loadEditDataClerksModal (index) {
      // get the row details
      const rowData = this.dataClerksReportData[index]

      this.goal = rowData.goal
      this.percentageAchieved = rowData.percentageAchieved
      this.supervisorScore = rowData.supervisorScore

      // set the index to be edited
      this.selectedEditIndex = index
      this.openDataClerksReportEditModal()
    },

    // load the edit modal
    loadEditMultiFunctionServiceModal (index) {
      // get the row details
      const rowData = this.multiFunctionServiceReportData[index]

      this.description = rowData.description
      this.planned = rowData.planned
      this.achieved = rowData.achieved
      this.completion = rowData.completion
      this.observations = rowData.observations

      // set the index to be edited
      this.selectedEditIndex = index
      this.openMultiFunctionServiceReportEditModal()
    },
    // delete an item from the
    deleteServiceReportItem (index) {
      // remove the grand total
      this.removeServiceDeliveryGrandTotal()

      // delete the item
      this.serviceReportData.splice(index, 1)
      this.calculateServiceDeliveryGrandTotal()
    },

    // delete an item from the
    deleteDataClerkItem (index) {
      // remove the grand total
      this.removeDataClerksGrandTotal()

      // delete the item
      this.dataClerksReportData.splice(index, 1)
      this.calculateDataClerksGrandTotal()
    },
    // delete an item from the
    deleteMultiFunctionServiceReportItem (index) {
      // delete the item
      this.multiFunctionServiceReportData.splice(index, 1)
    }, 

    // remove the last row
    removeServiceDeliveryGrandTotal () {
      // only if the data is > 0
      const size = this.serviceReportData.length
      if (size > 0) {
        // remove the percentage and grand total
        this.serviceReportData.pop()
        this.serviceReportData.pop()
      }
      // console.log(this.serviceReportData)
    },
    // remove the last row
    removeMieIntlGrandTotal () {
      // only if the data is > 0
      const size = this.mieIntlData.length
      if (size > 0) {
        this.mieIntlData.splice((size -1), 1)
      }
    },
    // remove the last row
    removeDataClerksGrandTotal () {
      // only if the data is > 0
      const size = this.dataClerksReportData.length
      if (size > 0) {
        this.dataClerksReportData.pop()
      }
    },
    // calulates the grand total
    calculateServiceDeliveryGrandTotal () {
      // get the data size
      const size = this.serviceReportData.length

      if (size > 0) {
        // if (size > 0) {
        // sorting the data
        this.serviceReportData.sort((a, b) => {
          if (a.date < b.date) {
            return -1
          } else if (a.date > b.date) {
            return 1
          } else {
            return 0
          }
        })
          
        // }

        let alcancarTotal = 0
        let viivTotal = 0
        let jdcTotal = 0
        let gatesTotal = 0
        let grandTotal = 0


        let alcancarPercentage = 0
        let viivPercentage = 0
        let jdcPercentage = 0
        let gatesPercentage = 0
        let grandPercentage = 0
        
        // set the total amounts and the percentage totals
        for (let i = 0; i < size; i++) {
          const row = this.serviceReportData[i]
          const alcancarAmount = row.alcancar
          const viivAmount = row.viiv
          const jdcAmount = row.jdc
          const gatesAmount = row.gates

          // add the totals
          alcancarTotal += Number(alcancarAmount)
          viivTotal += Number(viivAmount)
          jdcTotal += Number(jdcAmount)
          gatesTotal += Number(gatesAmount)
        }

        // calculating the grand total
        grandTotal = alcancarTotal + viivTotal + jdcTotal + gatesTotal

        // calculating the percentages
        if (grandTotal !== 0) {
          alcancarPercentage = ((alcancarTotal/grandTotal) * 100).toFixed(1)
          viivPercentage = ((viivTotal/grandTotal) * 100).toFixed(1)
          jdcPercentage = ((jdcTotal/grandTotal) * 100).toFixed(1)
          gatesPercentage = ((gatesTotal/grandTotal) * 100).toFixed(1)
          grandPercentage = ((grandTotal/grandTotal) * 100).toFixed(1)
        }

        const totalRowData =  {
                                date: 'Total',
                                alcancar: alcancarTotal,
                                viiv: viivTotal,
                                jdc: jdcTotal,
                                gates: gatesTotal,
                                total: grandTotal,
                                observations: ''
                              }
        
        const percentageRowData =  {
                                      date: 'Percentage',
                                      alcancar: alcancarPercentage,
                                      viiv: viivPercentage,
                                      jdc: jdcPercentage,
                                      gates: gatesPercentage,
                                      total: grandPercentage,
                                      observations: ''
                                    }


        // add it in the percentage row data
        this.serviceReportData.push(totalRowData)
        this.serviceReportData.push(percentageRowData)

        // save the state
        this.saveReport()
      }
    },
    // calulates the grand total
    calculateDataClerksGrandTotal () {
      // get the data size
      const size = this.dataClerksReportData.length

      if (size > 0) {
        // calculate the grand total
        let achievedPercentageTotal = 0
        let supervisorScoreTotal = 0

        for (let i = 0; i < size; i++) {
          const rowData = this.dataClerksReportData[i]
          const achievedPercentage = Number(rowData.percentageAchieved)
          const supervisorScore = Number(rowData.supervisorScore)

          achievedPercentageTotal += achievedPercentage
          supervisorScoreTotal += supervisorScore
        }

        achievedPercentageTotal = (achievedPercentageTotal/(100 * size)) * 100

        const rowData = {
          goal: 'Total',
          percentageAchieved: achievedPercentageTotal,
          supervisorScore: supervisorScoreTotal
        }

        // add it in the data clerks [] data
        this.dataClerksReportData.push(rowData)

        // save the state
        this.saveReport()
      }
    },
    // check the start and end date
    isDateGreaterThan(endDate, startDate) {
        // Ensure both dates are Date objects
        const date1 = new Date(endDate);
        const date2 = new Date(startDate);
        if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
          throw new Error("Both arguments must be Date objects.");
        }

        // Compare the timestamps
        return date1.getTime() >= date2.getTime();
    },

    // add mie data
    addServiceReportData () {
        if (this.date.trim() !== '' && !isNaN(this.alcancar) && !isNaN(this.viiv) && !isNaN(this.jdc) && !isNaN(this.gates) && this.observations.trim() !== '') {
          // remove the grand total
          this.removeServiceDeliveryGrandTotal()

          const total = Number(this.alcancar) + Number(this.viiv) + Number(this.jdc) + Number(this.gates)

          const rowData = {
            date: this.date,
            alcancar: this.alcancar,
            viiv: this.viiv,
            jdc: this.jdc,
            gates: this.gates,
            total: total,
            observations: this.observations
          } 
     

          if (!this.compareRows(this.serviceReportData, rowData)) {
            // add it in the mie
            this.serviceReportData.push(rowData)

            // calculate the grand total
            this.calculateServiceDeliveryGrandTotal()
          }

          //  close the add a schedule modal
          this.closeServiceReportAddModal()
        } else {
          // console.log(this.selectedLocation.name !== undefined, this.startDate !== '', this.endDate !== '', this.selectedBreakfast.name, this.selectedLunch !== undefined, this.selectedDinner.name !== undefined, this.selectedIncidental.name !== undefined)
        }
    },
    // edit mie data
    editServiceReportData () {
        // check if the details are empty
        if (this.date.trim() !== '' && !isNaN(this.alcancar) && !isNaN(this.viiv) && !isNaN(this.jdc) && !isNaN(this.gates) && this.observations.trim() !== '') {
          // remove the grand total
          this.removeServiceDeliveryGrandTotal()

          const total = Number(this.alcancar) + Number(this.viiv) + Number(this.jdc) + Number(this.gates)

          const rowData = {
            date: this.date,
            alcancar: this.alcancar,
            viiv: this.viiv,
            jdc: this.jdc,
            gates: this.gates,
            total: total,
            observations: this.observations
          } 

          
          // add it in the mie
          this.serviceReportData[this.selectedEditIndex] = rowData

          // calculate the grand total
          this.calculateServiceDeliveryGrandTotal()

          //  close the add a schedule modal
          this.closeServiceReportEditModal()
        } else {
          // console.log(this.selectedLocation.name !== undefined, this.startDate !== '', this.endDate !== '', this.selectedBreakfast.name, this.selectedLunch !== undefined, this.selectedDinner.name !== undefined, this.selectedIncidental.name !== undefined)
        }
    },
    // format the table data
    formatData (data) {
      var formattedData
      // check if it is a number
      if (data !== null && data !== undefined && !isNaN(data) && String(data).length > 2) {
        // format the number to a currency format
        var currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MWK' })
        formattedData = currencyFormat.format(String(data)).substring(4)
      } else if (data !== null && data !== undefined && data.toString().includes('-') && !isNaN(Date.parse(data))) {
        // check if the data is a date
        // formating the dates supplied
        var textDate = new Date(data)
        var formattedTextDate = textDate.getDate() + ' ' + this.months[textDate.getMonth()] + ' ' + textDate.getFullYear()
        formattedData = formattedTextDate
      } else {
        formattedData = data
      }
      return formattedData
    },
    // clear the mie data
    clearData () {
       if (this.createServiceReportStep1?.serviceReportType?.name === 'Service Report') {
        this.serviceReportData = []

      } else if(this.createServiceReportStep1?.serviceReportType?.name === 'Data Clerks Report') {
        this.dataClerksReportData = []

      } else {
        this.multiFunctionServiceReportData = []
      
      }
    },
    // move to the previous page
    back () {
      this.$router.push('/create-service-report-1')
    },
    // move to the next page
    next () {
      if (this.createServiceReportStep2?.data.length > 0) {
        // move to the last step
        this.$router.push('/create-service-report-3')
      } else {
        // show the error
        // close the loader modal
        this.$refs.loaderRef.closeModal()
        // showing the dialog for the error
        this.processMessage = 'Fill the report to continue.'
        // open the error modal
        this.$refs.messageRef.openModal()
      }
    },
    // expands or collapses the main body
    expand (value) {
      this.expandBody = value
    }
  }
}
</script>

<style>

#chart-container {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  height: 40vh;
}

</style>
